import React from 'react';
import {findDOMNode} from 'react-dom';
import './dialogs.less';

export default class Modal extends React.Component {

	componentDidMount() {

		var $me = $(findDOMNode(this));

		$me.on('hide', this.onHide.bind(this));

		$me.modal('show');

	}

	componentWillUnmount() {

		var $me = $(findDOMNode(this));

		$me.off();
		$me.modal('hide');
	}

	onHide(event) {

		//don't let the modal close itself, we own this mutha fucka
		event.preventDefault();

		if (this.props.onClose) {
			this.props.onClose();
		}
	}

	onCancelButtonClicked(event) {
		if (this.props.onCancelButtonClicked) {
			this.props.onCancelButtonClicked();
		} else {
			this.props.onClose();
		}
	}

	onSaveButtonClicked(event) {
		if (this.props.onSaveButtonClicked) {
			this.props.onSaveButtonClicked();
		}
	}

	onOkButtonClicked(event) {
		if (this.props.onOkButtonClicked) {
			this.props.onOkButtonClicked();
		}
	}

	render() {
		var className = this.props.className ? `modal hide fade ${this.props.className}` : 'modal hide fade';
		return (
			<div className={className}>

				{this.props.showTitleBar &&

					<div className="modal-header">

						{this.props.showCloseButton && 
							<button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
						}

						<h3>{this.props.title}</h3>

					</div>

				}

				<div className="modal-body">
					{this.props.children}
				</div>

			  {(this.props.actionButton || this.props.showCancelButton || this.props.showSaveButton || this.props.showOkButton) &&

				  <div className="modal-footer">
			  		
				    {this.props.showCancelButton &&
				    	<a onClick={this.onCancelButtonClicked.bind(this)} className="btn">{this.props.cancelButtonLabel}</a>
				    }

				    {this.props.actionButton}

				    {!this.props.actionButton && this.props.showSaveButton &&
				    	<a onClick={this.onSaveButtonClicked.bind(this)} className="btn btn-primary">{this.props.saveButtonLabel}</a>
				    }

				    {!this.props.actionButton && this.props.showOkButton &&
				    	<a onClick={this.onOkButtonClicked.bind(this)} className="btn btn-primary">{this.props.okButtonLabel}</a>
				    }

				  </div>
			  
			  }

			</div>
		);
	}


}


Modal.propTypes = {
	title: React.PropTypes.string.isRequired,
	onClose: React.PropTypes.func,
	onCancelButtonClicked: React.PropTypes.func,
	onSaveButtonClicked: React.PropTypes.func,
	onOkButtonClicked: React.PropTypes.func,
	showTitleBar: React.PropTypes.bool,
	showCloseButton: React.PropTypes.bool,
	showCancelButton: React.PropTypes.bool,
	showSaveButton: React.PropTypes.bool,
	showOkButton: React.PropTypes.bool,
};

Modal.defaultProps = { 
	showTitleBar: true,
	showCloseButton: true,
	showCancelButton: true,
	showSaveButton: true,
	showOkButton: false,
	title: "Save changes",
	cancelButtonLabel: "Cancel",
	saveButtonLabel: "Save changes",
	okButtonLabel: "OK",
};



// WEBPACK FOOTER //
// ./app/b3/dialogs/Modal.js